import request from "@/CommonDP/utils/request";

// 轻量化监控
export default {
  // charts统计数据
  getCount(params) {
    return request.post(`/light/count/status`, params);
  },
  // charts统计详细数据
  getCountDetail(params) {
    return request.post(`/light/count/detail`, params);
  },
  // 轻量化表格数据
  getList(params) {
    return request.post(`/light/count/page`, params);
  },
  // 重试
  resetAgain(prjId, fileId, fileVersion) {
    return request.get(`/doc/re-convert/${prjId}/${fileId}?version=${fileVersion}`);
  },
  // 优先
  precedence(convertTaskId) {
    return request.get(`/light/precedence?convertTaskId=${convertTaskId}`);
  },
  // 查询可轻量化格式类型
  queryAllFileType() {
    return request.get(`/light/count/queryAllFileType`);
  }
};
